var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"interaction",staticStyle:{"transition":"all 0.2s"},on:{"touchstart":_vm.touchStart,"touchend":_vm.touchEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }